import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';

export function SysctlItem({ item, onChange, index }: ItemProps<string>) {
  return (
    <InputGroup size="small">
      <InputGroup.Addon>Sysctl</InputGroup.Addon>
      <InputGroup.Input
        type="text"
        className="form-control"
        value={item}
        onChange={(e) => onChange(e.target.value)}
        data-cy={`forbidden-sysctl-${index}-input`}
      />
    </InputGroup>
  );
}
